const CountryEnum = {
  CHILE: 'Chile',
  MEXICO: 'Mexico',
  DEFAULT: 'Chile',
};

export default CountryEnum;
